import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

export default function AdminEmpresas() {
  const [empresas, setEmpresas] = useState([])
  const [planes, setPlanes] = useState([])
  const [buscar, setBuscar] = useState('')
  const [filterEstado, setFilterEstado] = useState('')
  const [showCrear, setShowCrear] = useState(false)
  const [showPlan, setShowPlan] = useState(null)
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', planId: '', adminNombre: '', adminEmail: '', adminPassword: '', diasTrial: 14 })
  const [planForm, setPlanForm] = useState({ planId: '', mesesExtension: 1 })

  const cargar = async () => {
    const { data } = await api.get('/admin/sa/empresas', { params: { buscar, estado: filterEstado } })
    setEmpresas(data)
  }
  useEffect(() => { cargar() }, [buscar, filterEstado])
  useEffect(() => { api.get('/admin/sa/planes').then(r => setPlanes(r.data)) }, [])

  const crear = async (e) => {
    e.preventDefault()
    try {
      await api.post('/admin/sa/empresas', form)
      toast.success('Empresa creada')
      setShowCrear(false)
      setForm({ nombre: '', email: '', telefono: '', planId: '', adminNombre: '', adminEmail: '', adminPassword: '', diasTrial: 14 })
      cargar()
    } catch (e) { toast.error(e.response?.data?.error || 'Error') }
  }

  const cambiarEstado = async (id, estado) => {
    await api.post(`/admin/sa/empresas/${id}/estado`, { estado })
    toast.success(`Estado: ${estado}`)
    cargar()
  }

  const cambiarPlan = async (e) => {
    e.preventDefault()
    try {
      await api.post(`/admin/sa/empresas/${showPlan.id}/plan`, planForm)
      toast.success('Plan actualizado')
      setShowPlan(null)
      cargar()
    } catch (e) { toast.error(e.response?.data?.error || 'Error') }
  }

  const eliminar = async (id) => {
    if (!window.confirm('⚠️ Eliminar empresa Y TODOS sus datos (chats, contactos, etc.)? Esto NO se puede deshacer.')) return
    await api.delete(`/admin/sa/empresas/${id}`)
    toast.success('Eliminada')
    cargar()
  }

  const estadoColor = { activa: 'badge-success', trial: 'badge-info', suspendida: 'badge-warning', cancelada: 'badge-danger' }

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <h1 className="text-2xl font-bold">🏢 Empresas</h1>
        <button className="btn btn-primary" onClick={() => setShowCrear(true)}>+ Nueva empresa</button>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="flex gap-3 search-bar">
          <input className="input" placeholder="🔍 Buscar..." value={buscar} onChange={e => setBuscar(e.target.value)} />
          <select className="select" value={filterEstado} onChange={e => setFilterEstado(e.target.value)}>
            <option value="">Todos los estados</option>
            <option value="activa">Activa</option>
            <option value="trial">Trial</option>
            <option value="suspendida">Suspendida</option>
            <option value="cancelada">Cancelada</option>
          </select>
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table table-card">
          <thead>
            <tr><th>Empresa</th><th>Plan</th><th>Estado</th><th>Recursos</th><th>Vence</th><th></th></tr>
          </thead>
          <tbody>
            {empresas.map(e => (
              <tr key={e.id}>
                <td data-label="Empresa">
                  <div>
                    <div className="font-semibold">{e.nombre}</div>
                    <div className="text-sm text-muted">{e.email}</div>
                  </div>
                </td>
                <td data-label="Plan">{e.Suscripcion?.Plan?.nombre || '-'}</td>
                <td data-label="Estado"><span className={`badge ${estadoColor[e.estado]}`}>{e.estado}</span></td>
                <td data-label="Recursos" className="text-sm">
                  📱 {e.contadores.sesiones} · 🧑 {e.contadores.usuarios} · 👥 {e.contadores.contactos}
                </td>
                <td data-label="Vence">{e.Suscripcion?.fin ? new Date(e.Suscripcion.fin).toLocaleDateString() : '-'}</td>
                <td>
                  <div className="flex gap-1">
                    <button className="btn btn-sm btn-primary" onClick={() => { setShowPlan(e); setPlanForm({ planId: e.Suscripcion?.planId || '', mesesExtension: 1 }) }}>💎 Plan</button>
                    {e.estado === 'activa' ? (
                      <button className="btn btn-sm" onClick={() => cambiarEstado(e.id, 'suspendida')}>Suspender</button>
                    ) : (
                      <button className="btn btn-sm btn-success" onClick={() => cambiarEstado(e.id, 'activa')}>Activar</button>
                    )}
                    <button className="btn btn-sm btn-danger" onClick={() => eliminar(e.id)}>🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {empresas.length === 0 && <div className="empty-state">Sin empresas</div>}
      </div>

      {showCrear && (
        <div className="modal-overlay" onClick={() => setShowCrear(false)}>
          <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">Nueva empresa</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowCrear(false)}>✕</button>
            </div>
            <form onSubmit={crear}>
              <div className="modal-body">
                <h4 style={{ marginBottom: 10 }}>Datos de la empresa</h4>
                <div className="form-group"><label className="form-label">Nombre</label><input className="input" required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Email</label><input className="input" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Teléfono</label><input className="input" value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} /></div>

                <div className="flex gap-3">
                  <div className="form-group flex-1">
                    <label className="form-label">Plan</label>
                    <select className="select" required value={form.planId} onChange={e => setForm({...form, planId: e.target.value})}>
                      <option value="">-- Seleccionar --</option>
                      {planes.map(p => <option key={p.id} value={p.id}>{p.nombre} - ${p.precio}/{p.ciclo}</option>)}
                    </select>
                  </div>
                  <div className="form-group flex-1">
                    <label className="form-label">Días de trial</label>
                    <input type="number" className="input" value={form.diasTrial} onChange={e => setForm({...form, diasTrial: parseInt(e.target.value)})} />
                  </div>
                </div>

                <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid var(--border)' }} />
                <h4 style={{ marginBottom: 10 }}>Administrador inicial</h4>
                <div className="form-group"><label className="form-label">Nombre del admin</label><input className="input" required value={form.adminNombre} onChange={e => setForm({...form, adminNombre: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Email del admin (login)</label><input className="input" type="email" required value={form.adminEmail} onChange={e => setForm({...form, adminEmail: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Contraseña</label><input className="input" type="text" required value={form.adminPassword} onChange={e => setForm({...form, adminPassword: e.target.value})} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowCrear(false)}>Cancelar</button>
                <button className="btn btn-primary">Crear empresa</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showPlan && (
        <div className="modal-overlay" onClick={() => setShowPlan(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">Cambiar plan: {showPlan.nombre}</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowPlan(null)}>✕</button>
            </div>
            <form onSubmit={cambiarPlan}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Plan</label>
                  <select className="select" required value={planForm.planId} onChange={e => setPlanForm({...planForm, planId: e.target.value})}>
                    {planes.map(p => <option key={p.id} value={p.id}>{p.nombre} - ${p.precio}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Extender (meses adicionales)</label>
                  <input type="number" min="1" className="input" value={planForm.mesesExtension} onChange={e => setPlanForm({...planForm, mesesExtension: parseInt(e.target.value)})} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowPlan(null)}>Cancelar</button>
                <button className="btn btn-primary">Actualizar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
